import { put, takeEvery } from 'redux-saga/effects';
import { searchFormsResult, fetchFormsFailure } from 'redux/forms/actions';
import request from 'utils/request';
import urls from 'utils/config';
import FormsActionTypes from '../types';

const { FORM_API_BASE_URL } = urls || {};

function* searchForms({ data }) {
  const { searchPattern, pageSize = 10 } = data;
  const url = `${FORM_API_BASE_URL}/designs?&size=${
    pageSize || 10
  }&name=${searchPattern}`;

  const response = yield request({
    method: 'get',
    url,
  });
  if (response.success) {
    yield put(searchFormsResult(response.raw));
  } else {
    yield put(fetchFormsFailure(response.message));
  }
}

function* searchFormByStatus({ payload }) {
  const { formStatus, pageSize = 10, pageNumber } = payload;
  const url = `${FORM_API_BASE_URL}/designs?index=${pageNumber}&size=${
    pageSize || 10
  }&active=${formStatus}`;

  const response = yield request({
    method: 'get',
    url,
  });
  if (response.success) {
    yield put(searchFormsResult(response.raw));
  } else {
    yield put(fetchFormsFailure(response.message));
  }
}

export function* onSearchForms() {
  yield takeEvery(FormsActionTypes.SEARCH_FORMS, searchForms);
}

export function* onSearchFormByStatus() {
  yield takeEvery(FormsActionTypes.SEARCH_FORMS_BY_STATUS, searchFormByStatus);
}
